module.exports = __webpack_public_path__ + "static/media/image9.54155a96.png";